import React, { Component } from 'react';
import PropTypes from 'prop-types';
import autobind from 'react-autobind';

export default class DeleteNotification extends Component {
  constructor(...args) {
    super(...args);
    autobind(this);
  }

  state = { show: this.props.defaultShow };

  onShow() {
    if (this.props.autoHide) {
      setTimeout(this.close, this.props.autoHideTimeout);
    }
    if (this.props.onShow) {
      this.props.onShow();
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ show: nextProps.defaultShow });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.show && !prevState.show) {
      this.onShow();
    }
  }

  componentDidMount() {
    this._isMounted = true; // eslint-disable-line no-underscore-dangle
    if (this.state.show) {
      this.onShow();
    }
  }

  componentWillUnmount() {
    this._isMounted = false; // eslint-disable-line no-underscore-dangle
  }

  getUndoButton() {
    if (!this.props.undoAction) return null;
    return <div className="margin-top-ml"><button key={'undo'} className={'tds-btn tds-btn--md tes-notification__button tes-notification__button--confirm tds-btn--primary-inverse'} onClick={this.props.undoAction}>Undo</button></div>;
  }

  componentWillMount() {
    this.props.children.push(this.getUndoButton());
  }

  close() {
    if (this._isMounted) { // eslint-disable-line no-underscore-dangle
      this.setState({ show: false });
      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }

  render() {
    const bemModifier = (toAdd, modifier) => (toAdd ? `${modifier}` : '');
    const classes = `tes-notification tds-panel tes-notification--warning tds-panel--icon-left${bemModifier(this.state.show, ' tes-notification--active')}`;

    return (
      <div>
        <div className={classes}>
          <div className="tes-notification__wrapper">
            <div className="tes-notification__content">
              <div className="tes-notification__text">
                <div className="tes-notification__message">
                  {this.props.children}
                </div>
              </div>
            </div>
            {this.props.closable
              && <button type="button" className="tds-panel__button" onClick={this.close}>
                <span className="sr-only">Close</span>
              </button>
            }
          </div>
        </div>
      </div>
    );
  }
}

DeleteNotification.propTypes = {
  closable: PropTypes.bool,
  onClose: PropTypes.func,
  onShow: PropTypes.func,
  autoHideTimeout: PropTypes.number,
  autoHide: PropTypes.bool,
  defaultShow: PropTypes.bool,
  blockUI: PropTypes.bool,
  children: PropTypes.node,
  align: PropTypes.string,
  undoAction: PropTypes.func,
};

DeleteNotification.defaultProps = {
  closable: true,
  defaultShow: false,
  autoHideTimeout: 3000,
  autoHide: false,
  blockUI: false,
};
